/**
 * Calculate dispatch date by adding working days (skipping weekends) to today.
 *
 * @param {number} workingDays — number of production/working days
 * @returns {{ short: string, long: string, date: Date }}
 *   short: "dd/mm" (for compact display)
 *   long:  "Fri 18 Apr" (for human-friendly display)
 *   date:  the raw Date object
 */
function getDispatchDate(workingDays) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  let remaining = Number(workingDays);
  const current = new Date();
  let extra = 0;

  while (remaining > -1) {
    current.setDate(current.getDate() + 1);
    const dow = current.getDay();
    if (dow === 0 || dow === 6) {
      extra++;
    } else {
      remaining--;
    }
  }

  const dispatch = new Date();
  dispatch.setDate(dispatch.getDate() + Number(workingDays) + extra);

  const dd = String(dispatch.getDate()).padStart(2, '0');
  const mm = String(dispatch.getMonth() + 1).padStart(2, '0');

  return {
    short: `${dd}/${mm}`,
    long: `${days[dispatch.getDay()]} ${dispatch.getDate()} ${months[dispatch.getMonth()]}`,
    date: dispatch
  };
}

window.getDispatchDate = getDispatchDate;
